import type { ReactNode } from 'react';

export const symbol_directions_alt: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-77q-12 0-23.5-4T437-93L93-437q-8-8-12-19.5T77-480q0-12 4-23.5T93-523l344-344q8-8 19.5-12t23.5-4q12 0 23.5 4t19.5 12l344 344q8 8 12 19.5t4 23.5q0 12-4 23.5T867-437L523-93q-8 8-19.5 12T480-77ZM308-308l172 172 344-344-344-344-344 344 172 172Zm172-172Zm81 30L458-347q-9 9-8.5 21t9.5 21q9 9 21.5 9t21.5-9l154-154q9-9 9-21t-9-21L501-656q-9-9-21-9t-21 9q-9 9-9 21.5t9 21.5l102 103H313q-13 0-21.5 8.5T283-480q0 13 8.5 21.5T313-450h248Z"
		/>
	</svg>
);
